<script>
import { mapState, mapMutations } from 'vuex'
import { fb } from '@/lib/common'
export default {
  computed: {
    ...mapState([
      'user'
    ])
  },
  methods: {
    ...mapMutations([
      'setUser'
    ]),
    signOut () {
      fb.auth().signOut()
        .then(() => {
          this.setUser(null)
          console.log('Sign-out successful')
        })
        .catch(error => console.error(error))
    }
  }
}
</script>

<template>
  <div
    v-if="user"
    class="account level is-mobile"
  >
    <div class="level is-mobile">
      <i class="material-icons">account_circle</i>
      <span>{{ user.email }}</span>
    </div>
    <div>
      <button
        @click="signOut"
        class="button"
      >
        <i class="material-icons">logout</i>
        <span>サインアウト</span>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.account {
  > * {
    margin: 0 .5rem;
  }
}
</style>
